import React from 'react';
import PropTypes from 'prop-types';
import { Icon } from 'edcom-ui';
import styles from './FilterChips.module.less';

export default function FilterChips({
  filters,
  clickFilterChip,
  handleClearAllClick,
}) {
  //query is guranteed to be the last filter based on search.js in content-service
  const queryExist =
    filters.length > 0 && filters[filters.length - 1].group === 'q';

  const renderFilterChips = filters.map((element, i) => {
    if (!queryExist && element.group === 'contentType') {
      return null;
    }
    const title =
      element.group === 'q'
        ? 'Remove search term'
        : `Remove filter: ${element.display.toUpperCase()}`;
    const displayName = element.display;
    const remove = () => clickFilterChip(element.href);

    return element.group === 'q' ? null : (
      <div
        className={styles.chip}
        title={title}
        onClick={remove}
        key={`remove-filter-${i}`}
        role="link"
      >
        <div className={styles.chipText}>{displayName}</div>
        <Icon name="cancel-thin" className={styles.cancel} />
      </div>
    );
  });

  const clearAllChip = (
    <div
      className={styles.chipClearAll}
      title={'Clear All'}
      onClick={handleClearAllClick}
    >
      <a>Clear All</a>
    </div>
  );
  // Only display Clear All chip when a filter chip is visible
  if (renderFilterChips.length > 1) {
    renderFilterChips.push(clearAllChip);
  }

  return <>{renderFilterChips}</>;
}

FilterChips.propTypes = {
  filters: PropTypes.arrayOf(
    PropTypes.shape({
      display: PropTypes.string,
      group: PropTypes.string,
      href: PropTypes.string,
    })
  ).isRequired,
  clickFilterChip: PropTypes.func,
  handleClearAllClick: PropTypes.func,
};
